export const SERVICE_URL = process.env.REACT_APP_SERVICE_URL;
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const GRAPHQL_URL = process.env.REACT_APP_GRAPHQL_URL;
export const GRAPHQL_WS_URL = process.env.REACT_APP_GRAPHQL_WS_URL;